// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7.10002 11C7.56329 8.71776 9.58104 7 12 7C14.419 7 16.4367 8.71776 16.9 11H23V13H16.9C16.4367 15.2822 14.419 17 12 17C9.58104 17 7.56329 15.2822 7.10002 13H1V11H7.10002Z"}}]};

const GitCommitFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'git-commit-filled',
    ref,
    icon: element,
  },
));

GitCommitFilledIcon.displayName = 'GitCommitFilledIcon';

export default GitCommitFilledIcon;
